import { Component, Input, Output } from '@angular/core';
import { BaseComponent } from '../base-components/base-component.component';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-edit-coupons',
    template: `
        <div class="d-flex flex-row gap-1">
            <button class="d-flex gap-2 align-items-center action-button" (click)="onEditItem()">
                <img class="icon icon-btn" src="assets/icon/edit.png" />
            </button>
            <button class="d-flex gap-2 align-items-center action-button" (click)="onNavigateToCoupon()">
                <div class="button-text">
                    {{ 'partner.coupons' | translate }}
                </div>
            </button>
        </div>
    `,
    styles: [
        `
            .icon {
                width: 24px;
                height: 24px;
            }

            .icon-btn {
                cursor: pointer;
            }
        `,
    ],
})
export class EditCouponsComponent extends BaseComponent {
    public iconSrc: string;

    @Output()
    emitter = new Subject<{ action: string; data: any }>();

    @Input()
    data: any = {};

    ngOnInit() {
        console.log(this.data)
    }

    onEditItem() {
        this.emitter.next({
            action: 'edit',
            data: this.data,
        });
    }

    onNavigateToCoupon() {
        this.emitter.next({
            action: 'coupon',
            data: this.data,
        });
    }
    onNavigateToUserEdit() {
        this.emitter.next({
            action: 'user-edit',
            data: this.data,
        });
    }
}
